import React from 'react';
import ProductRow from '../components/ProductRow';
import products from '../data/products';

function OrderPage() {
  return (
    <>
      <h2>Order Page</h2>
      <article>
        <p>On this page, you can place an order from our list of products.</p>
        <table id="games">
          <caption>Products</caption>
          <thead>
            <tr>
              <th>Brand</th>
              <th>Product</th>
              <th>Price</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product, index) => (
              <ProductRow product={product} key={index} />
            ))}
          </tbody>
        </table>
      </article>
    </>
  );
}

export default OrderPage;
